import { BaseFetch } from "../main-model";
export default class DirectorModel extends BaseFetch {
  getDirectorBy = (data) =>
    this.authFetch({
      url: "director/getDirectorBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  getDirectorByAcademicYear = (data) =>
    this.authFetch({
      url: "director/getDirectorByAcademicYear",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertDirector = (data) =>
    this.authFetch({
      url: "director/insertDirector",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateDirectorById = (data) =>
    this.authFetch({
      url: "director/updateDirectorById",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteDirectorById = (data) =>
    this.authFetch({
      url: "director/deleteDirectorById",
      method: "POST",
      body: JSON.stringify(data),
    });
}
